import { useEffect, useState } from "react";

// Shared state for the two-tap inline destructive confirm idiom
// (trash/✕ → "Confirm?" → second tap executes). Once armed it auto-reverts
// after `delayMs`, so a stale destructive label can never sit waiting for an
// accidental tap — the exit the hand-rolled copies were missing (HR-8; the
// 4th copy was the §CONSOLIDAMENTO trigger). Drop-in for the previous
// `useState(false)` pattern: same [armed, setArmed] tuple, callers keep
// their arm/execute logic untouched. 6s window: a screen-reader or
// motor-impaired user needs to hear the label, decide and double-tap —
// 4s was tight for exactly the users the auto-revert protects.
export function useArmedConfirm(
  delayMs = 6000,
): [boolean, (armed: boolean) => void] {
  const [confirming, setConfirming] = useState(false);
  useEffect(() => {
    if (!confirming) return;
    const id = setTimeout(() => setConfirming(false), delayMs);
    return () => clearTimeout(id);
  }, [confirming, delayMs]);
  return [confirming, setConfirming];
}
